import { gql } from "@apollo/client";

export const GET_ALL_PLAN_CUIDADO_DURACION_FASE = gql`
query GetAllPlanCuidadoDuracionFase {
    allPlanCuidadoDuracionFase{
            idPlanCuidadoDuracionFase,
            descripcion,
            duracion
      }
}`;